import { render } from "./v-employees-list.vue?vue&type=template&id=18047d17"
import script from "./v-employees-list.vue?vue&type=script&lang=js"
export * from "./v-employees-list.vue?vue&type=script&lang=js"

import exportComponent from "/builds/simplecrm/simplecrmfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__